import { call, put, takeLatest, select } from 'redux-saga/effects';
import { actions, constants } from './index';
import Api from 'utils/resources/purchaseOrders';

// FIN-1285: the companies and the budget year of the Purchase Orders page — the year its
// selector writes (settings.global.budgetYear), not the one the Invoices page keeps.
export const totalsParams = (state) => ({
  companyIds: state.settings.global.poCompanies,
  year: state.settings.global.budgetYear,
});

export function* fetchTotals() {
  try {
    const { companyIds, year } = yield select(totalsParams);
    // The list under the panel is not requested without a company; neither are its totals.
    if (!companyIds || !companyIds.length) {
      yield put(actions.clearTotals());
      return;
    }

    const options = { companyId: companyIds, year };
    const { data } = yield call(Api.totals, options);

    yield put(actions.setTotals(data));
  } catch (error) {
    yield put(actions.setErrors(error))
  }
};

// The latest request wins: a year switched twice, or the companies cleared while a request is
// out, would otherwise let an older answer overwrite the panel.
export default function getFeatureSagas() {
  return [
    takeLatest([
      constants.FETCH_TOTALS_REQUEST
    ], fetchTotals)
  ];
}
